module.exports = __webpack_public_path__ + "img/thought.0990cf3c.png";